import { atom, DefaultValue, selector } from "recoil";

export const rsState = atom({
    key: 'rsManagment',
    default: {
        listMobilityStore: [],
        generalInfo: {
            value:{}
        },
        additionalInfo: {},
        eparkingInfo: {},
        representativeInfo: {},
        financialInfo: {},
        associationInfo: {},
        document:[],
        repairShops: [],
        generalTimeFrame: [],
        specificTimeFrame: [],
        rsFilterParams: {}
    }
});

export const rsFilterParams = selector<any>({
    key: 'rsFilterParams',
    get: ({ get }) => get(rsState).rsFilterParams,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            rsFilterParams: newValue instanceof DefaultValue ? get(rsState).rsFilterParams : newValue
        })
    }
});

export const listMobilityStoreState = selector<any>({
    key: 'listMobilityStoreRS',
    get: ({ get }) => get(rsState).listMobilityStore,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            listMobilityStore: newValue instanceof DefaultValue ? get(rsState).listMobilityStore : newValue
        })
    }
});

export const generalInfoState = selector<any>({
    key: 'generalInfoStateValueRS',
    get: ({get}) => get(rsState).generalInfo.value,
    set: ({get, set}, newValue) => {
        set(rsState, {
            ...get(rsState),
            generalInfo: {
                ...get(rsState).generalInfo,
                value: newValue instanceof DefaultValue ? get(rsState).generalInfo.value : newValue
            }
        })
    }
});

export const additionalInfoState = selector<any>({
    key: 'additionalInfoRS',
    get: ({ get }) => get(rsState).additionalInfo,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            additionalInfo: newValue instanceof DefaultValue ? get(rsState).additionalInfo : newValue
        })
    }
});


export const eParkingState = selector<any>({
    key: 'eparkingInfo',
    get: ({ get }) => get(rsState).eparkingInfo,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            eparkingInfo: newValue instanceof DefaultValue ? get(rsState).eparkingInfo : newValue
        })
    }
});

export const representativeInfoState = selector<any>({
    key: 'representativeInfoRS',
    get: ({ get }) => get(rsState).representativeInfo,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            representativeInfo: newValue instanceof DefaultValue ? get(rsState).representativeInfo : newValue
        })
    }
});

export const financialInfoState = selector<any>({
    key: 'financialInfoRS',
    get: ({ get }) => get(rsState).financialInfo,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            financialInfo: newValue instanceof DefaultValue ? get(rsState).financialInfo : newValue
        })
    }
});

export const associationInfoState = selector<any>({
    key: 'rsAssociationInfo',
    get: ({ get }) => get(rsState).associationInfo,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            associationInfo: newValue instanceof DefaultValue ? get(rsState).associationInfo : newValue
        })
    }
});

export const repairShopsState = selector<any>({
    key: 'repairShops',
    get: ({get}) => get(rsState).repairShops,
    set: ({set, get}, newValue) => {
        set(rsState, {
            ...get(rsState),
            repairShops: newValue instanceof DefaultValue ? get(rsState).repairShops : newValue
        })
    }
})

export const documentsRsState = selector<any>({
    key: 'documentsRs',
    get: ({ get }) => get(rsState).document,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            document: newValue instanceof DefaultValue ? get(rsState).document : newValue
        })
    }
});

export const generalTimeframeRsState = selector<any>({
    key: 'generalTimeFrameRs',
    get: ({ get }) => get(rsState).generalTimeFrame,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            generalTimeFrame: newValue instanceof DefaultValue ? get(rsState).generalTimeFrame : newValue
        })
    }
});

export const specificTimeframeRsState = selector<any>({
    key: 'generalTimeframeRs',
    get: ({ get }) => get(rsState).specificTimeFrame,
    set: ({ set, get }, newValue) => {
        set(rsState, {
            ...get(rsState),
            specificTimeFrame: newValue instanceof DefaultValue ? get(rsState).specificTimeFrame : newValue
        })
    }
});

